import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__content">
        <p>&copy; 2025 ramakrishnan gopinath. all rights reserved. made with react</p>
      </div>
    </footer>
  );
};

export default Footer;
